export class CustomError extends Error {
  code?: string;
  status?: number;

  constructor(message: string, status?: number, code?: string) {
    super(message);

    this.status = status;
    this.code = code;
  }
}
